import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const btn = "mono text-[10px] uppercase tracking-widest px-3 py-1.5 rounded-full border transition-colors";
const err = (e) => toast.error(formatApiError(e?.response?.data?.detail) || "Failed");

export function JsonSettings({ url, testId }) {
  const [txt, setTxt] = useState("");
  useEffect(() => { api.get(url).then((r) => { const { id, _id, ...rest } = r.data; setTxt(JSON.stringify(rest, null, 2)); }); }, [url]);
  const save = async () => {
    let body; try { body = JSON.parse(txt); } catch { toast.error("Invalid JSON"); return; }
    try { const r = await api.patch(url, body); const { id, ...rest } = r.data; setTxt(JSON.stringify(rest, null, 2)); toast.success("Settings saved"); } catch (e) { err(e); }
  };
  return (
    <div className="space-y-2">
      <textarea value={txt} onChange={(e) => setTxt(e.target.value)} rows={18} data-testid={`${testId}-json`} className="w-full bg-black/50 border border-white/10 rounded-xl p-3 mono text-xs" />
      <button onClick={save} data-testid={`${testId}-save`} className={`${btn} border-[#00F0FF] text-[#00F0FF]`}>Save settings</button>
    </div>
  );
}

export default function ClickerAdminTab() {
  const [sub, setSub] = useState("members");
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  const load = () => api.get("/admin/clicker/members", { params: { q } }).then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const edit = async (uid, body) => { try { await api.post(`/admin/clicker/members/${uid}`, body); toast.success("Updated"); load(); } catch (e) { err(e); } };
  return (
    <div className="space-y-4" data-testid="admin-clicker-tab">
      <div className="flex gap-2">
        {[["members", "Players"], ["settings", "Game balance"]].map(([k, l]) => (
          <button key={k} onClick={() => setSub(k)} data-testid={`admin-clicker-sub-${k}`} className={`${btn} ${sub === k ? "border-[#FF2BD6] text-[#FF2BD6]" : "border-white/10 text-white/50"}`}>{l}</button>
        ))}
      </div>
      {sub === "settings" ? (
        <div>
          <p className="text-xs text-white/50 mb-2">Edit upgrade prices, booster strength, rewards, click limits (max_cps), and coin amounts per Stripe package. Package prices are fixed in Stripe.</p>
          <JsonSettings url="/admin/clicker/settings" testId="admin-clicker-settings" />
        </div>
      ) : !data ? <div className="mono text-xs animate-pulse">Loading…</div> : (
        <>
          <div className="grid grid-cols-3 gap-3">
            {Object.entries(data.stats).map(([k, v]) => <div key={k} className="glass rounded-xl p-3"><div className="mono text-[10px] uppercase text-white/40">{k}</div><div className="font-black text-xl">{v}</div></div>)}
          </div>
          <form onSubmit={(e) => { e.preventDefault(); load(); }}><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search player" className="bg-black/40 border border-white/10 rounded-full px-3 py-1.5 text-sm" /></form>
          <div className="space-y-1.5">
            {data.members.map((m) => (
              <div key={m.user_id} className="glass rounded-xl p-3 flex flex-wrap items-center gap-3 text-sm" data-testid={`admin-clicker-member-${m.user_id}`}>
                <b className="flex-1 min-w-[120px]">{m.name}</b>
                <span className="mono text-xs">Lv {m.level}</span>
                <span className="mono text-xs">{Math.floor(m.coins).toLocaleString()} coins</span>
                <span className="mono text-xs text-white/40">{m.taps_total} taps</span>
                {m.suspicious > 0 && <span className="mono text-[10px] text-[#FF003C]">⚠ {m.suspicious} flags</span>}
                <button onClick={() => { const v = Number(window.prompt("Coins to add (negative to remove)", "1000")); if (v) edit(m.user_id, { coins_delta: v }); }} className={`${btn} border-white/15`}>Adjust</button>
                <button onClick={() => window.confirm("Reset this player's progress?") && edit(m.user_id, { reset: true })} className={`${btn} border-white/15`}>Reset</button>
                <button onClick={() => edit(m.user_id, { is_banned: !m.is_banned })} className={`${btn} ${m.is_banned ? "border-[#39FF14]/40 text-[#39FF14]" : "border-[#FF003C]/40 text-[#FF003C]"}`}>{m.is_banned ? "Unban" : "Ban"}</button>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
